<template>
	<div
		class="right check_col check_col2 m_toggle"
		v-bind:class="{
			col_done: done,
			col_disable: this.$store.state.checkoutStage === 'info'
		}"
	>
		<modal name="hours-modal" height="auto" :delay="100">
			<hours-pop :shippingTimes="shippingTimesForPop" :selected="selectedHour" @Hour="handleSelected" />
		</modal>
		<h2 class="check_title" onclick="mobileToggle(this)">
			פרטי משלוח
			<SHIPP />
			<span class="ok-svg">
				<OK />
			</span>
			<span class="check_col_plus"></span>
		</h2>
		<div class="check_col_inner m_toggleInner">
			<div class="group fields_open" v-bind:class="{ hide: !showOpenEdits }">

        <div class="title_s">{{ isLocalPickUp ? 'מתי נוח לך להגיע?' : 'מתי נוח לך שנגיע?'}}</div>
        <div class="text">
          זמני האספקה המוצגים הינם לפי איזור החלוקה וזמני המשלוח הפנויים בעת שליחת ההזמנה. ניתן לקבל טווח זמן
          מדויק יותר של עד שעתיים, בסמוך למועד יציאת המשלוח כמפורט בסעיף 3.4 ב
          <a :href="terms_page" target="_blank">תקנון האתר</a>
        </div>

        <div class="change-to-local-pickup">
          <div v-if="!isLocalPickUp">לא מצאת תאריך פנוי? תמיד אפשר לבחור <a href="#" @click.prevent="changeToLocalPickup">איסוף עצמי</a></div>
          <div v-else class="green">איסוף עצמי ממרלו"ג כרמלה, הסדנא 5, חולון</div>
        </div>
				<div class="shipp_times">
					<div class="error_tx">עליך לבחור יום וטווח שעות למשלוח</div>
					<div>
						<div class="slotsLoader" v-if="!slotsLoaded && this.$store.state.checkoutStage === 'shippment'">
							<span>שניה.. כבר נציג לך את זמני המשלוח</span>
							<img :src="loaderSVGreen" alt="" />
						</div>
						<div
							class="shipp_time_row clearfix"
							v-for="shippingTime in shippingTimes"
							:key="shippingTime.date"
						>
							<div class="right shipp_time_col1">
								{{ shippingTime.day }}
								<span>{{ shippingTime.date }}</span>
							</div>
							<div class="right shipp_time_col2">
								<div
									class="right shipp_time_hour ease"
									v-for="shippingHour in shippingTime.hours"
									v-bind:class="{
										active:
											selectedHour.hourId == shippingHour.id &&
											selectedHour.slotIndex == shippingTime.date
									}"
									:key="shippingHour.id"
								>
									<a
										href="javascript:void(0);"
										@click="
											selectHour(
												$event,
												shippingHour.id,
												shippingTime.date,
												shippingHour.employee_number
											)
										"
									>
										{{ shippingHour.hour }}
									</a>
								</div>
							</div>
						</div>
						<div
							class="shipp_time_row clearfix"
							v-if="selectedFar.length > 0"
							v-for="(shippingTime, index) in selectedFar"
							:key="index"
						>
							<div class="right shipp_time_col1">
								{{ shippingTime.day }}
								<span>{{ shippingTime.date }}</span>
							</div>
							<div class="right shipp_time_col2">
								<div
									class="right shipp_time_hour ease"
									v-for="shippingHour in shippingTime.hours"
									v-bind:class="{
										active:
											selectedHour.hourId == shippingHour.id &&
											selectedHour.slotIndex == shippingTime.date
									}"
									:key="shippingHour.id"
								>
									<a
										href="javascript:void(0);"
										@click="
											selectHour(
												$event,
												shippingHour.id,
												shippingTime.date,
												shippingHour.employee_number
											)
										"
									>
										{{ shippingHour.hour }}
									</a>
								</div>
							</div>
						</div>
					</div>
					<input type="hidden" v-validate="'required'" name="ship_time" :value="jsonShip" />
				</div>
				<div class="green_link">
					<a href="javascript:void(0);" @click="openHours()">הצג זמני משלוח נוספים &nbsp;></a>
				</div>
				<div class="error_tx" v-if="showError">{{ timeErrorMsg }}</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits">
				<div class="title_s relative">
					זמן משלוח
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="shipmentTime"></div>
				<hr />
			</div>
			<div class="group fields_open" v-bind:class="{ hide: !showOpenEdits }">
				<div class="radio_row clearfix">
					<div class="right form_tx">
						אני רוצה מוצרים חלופיים
						<span class="red">*</span>
					</div>
					<div class="right wrap_tooltip">
						<div
							class="type_info hasTooltip"
							title="במקרה שאחד המוצרים שהזמנת חסר, האם לשים לך מוצר דומה במקומו?"
						>
							?
						</div>
					</div>
					<div class="right radio_choose">
						<label class="right form_check form_radio">
							<div class="form_check_tx">
								כן
								<input
									type="radio"
									name="order_alternateproducts"
									v-model="alternate"
									v-validate="'required'"
									value="כן"
								/>
								<span class="checkmark"></span>
							</div>
						</label>
						<label class="right form_check form_radio">
							<div class="form_check_tx">
								לא
								<input type="radio" name="order_alternateproducts" v-model="alternate" value="לא" />
								<span class="checkmark"></span>
							</div>
						</label>
					</div>
					<div class="error_tx right" v-if="errors.first('order_alternateproducts')">
						{{ errors.first("order_alternateproducts") }}
					</div>
				</div>
				<div class="clearfix">
					<label class="right form_check">
						<div class="form_check_tx">
							משלוח ללא שקיות ניילון
							<input type="checkbox" name="order_nobags" v-model="nobags" />
							<span class="checkmark"></span>
						</div>
					</label>
					<div class="right wrap_tooltip">
						<div
							class="type_info hasTooltip"
							title="איכות הסביבה חשובה לך?! ניתן לקבל משלוח עם כמה שפחות שקיות ניילון"
						>
							?
						</div>
					</div>
				</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits">
				<div class="text" v-html="shipmentAltBags"></div>
				<hr />
			</div>
			<div
				class="group addnotes toggleContainer fields_open"
				v-bind:class="{ hide: !showOpenEdits, active: firstShowComments }"
			>
				<div class="top_addnote">
					<a href="#" @click.prevent="order_comments_toggle">
						<span class="title_s">הערות</span>
						<span class="top_addnote-plus" :class="{hide: order_comments_open}">+ הוספת הערות</span>
						<span class="top_addnote-plus" :class="{hide: !order_comments_open}">- סגירת הערות</span>
					</a>
				</div>
				<div class="bottom_addnote" :style="{ display: firstShowComments || order_comments_open ? 'block' : 'none' }">
					<div class="clearfix">
						<div class="form_tx">הערה כללית</div>
						<div class="form_input">
							<input type="text" name="order_comments" maxlength="90" v-model="order_comments" />
						</div>
					</div>
					<div class="clearfix">
						<div class="form_tx">הערה לשליח</div>
						<div class="form_input">
							<input
								type="text"
								name="order_comments2"
								maxlength="90"
								v-model="order_comments2"
								placeholder="למשל , להשאיר ליד הדלת..."
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits && notes">
				<div class="title_s relative">
					הערות
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="notes"></div>
			</div>
			<div class="bt_green ease">
				<a href="javascript:void(0);" @click="changeTab('payment')">לסיכום ותשלום</a>
			</div>
		</div>
	</div>
</template>
<script>
	import HoursPop from "../Popups/HoursPopup";
	/** SVG import */
	import OK from "../../assets/img/ok.svg";
	import SHIPP from "../../assets/img/shipp.svg";
	import PEN from "../../assets/img/pen.svg";
  import {mapActions, mapGetters, mapState} from "vuex";
	export default {
		data() {
			return {
				terms_page: wpData.terms_page,
				editInputs: true,
				check: false,
				selectedHour: false,
				selectedDay: "",
				selectedFar: [],
				timeValid: false,
				showError: false,
				loaderSVGreen: wpData.assets_url + "/svg/loader-green.svg",
				firstShowComments: false,
				timeErrorMsg: "יש לבחור זמן משלוח.",
				loaded: false,
				alternate: this.$store.getters.userCheckoutInfo.alter_products
					? this.$store.getters.userCheckoutInfo.alter_products == "1"
						? "כן"
						: "לא"
					: "לא",
				nobags:
					this.$store.getters.userCheckoutInfo.order_nobags == "1"
						? this.$store.getters.userCheckoutInfo.order_nobags
						: "",
        order_comments_open: false,
				order_comments: "",
				order_comments2: this.$store.getters.userCheckoutInfo.order_comments2
					? this.$store.getters.userCheckoutInfo.order_comments2
					: "",
			};
		},
		watch: {
			slotsLoaded: function(value) {
				if (value) {
					if (this.$store.state.orderEdit) {
						let slotcheck = this.slots[this.selectedDay.date];
						let indexOfSlot = Object.values(this.slots).indexOf(slotcheck);
						if (indexOfSlot > 2) {
							this.handleSelected(this.selectedHour);
						}
					} else {
						this.selectedDay = [];
						this.selectedFar = [];
						this.selectedHour = false;
					}
				}
			},
			selectedHour: function(id) {
				if (typeof this.slots !== "object") return false;
				if (Object.keys(this.slots).length < 1) return false;

				const selectedDay = this.slots[id.slotIndex];
				if (!selectedDay) return false;

				const selected = {
					date: id.slotIndex,
					hour: "",
					day: "",
					id: id.hourId,
					office_core_employee_number: id.employee_number
				};

				let find = selectedDay.hours.find(hour => hour.id == id.hourId);
				if (!find) return false;

				selected.hour = find.hour;
				selected.day = this.slots[id.slotIndex].day;
				this.selectedDay = selected;
				this.timeValid = true;
				this.showError = false;
			}
		},
		computed: {
			...mapState(["orderEditMeta", "userLoggedInfo"]),
			...mapGetters({ slots: "getSlots", orderEdit: "orderEdit" }),
      isLocalPickUp() {
        return this.$store.state.localPickup;
      },
			showOpenEdits() {
				if (!this.editInputs) {
					return false;
				}
				return true;
			},
			shipmentTime() {
				if (this.selectedDay != "") {
					return (
						"יום " +
						this.selectedDay.day +
						" " +
						this.selectedDay.date +
						" בין השעות " +
						this.selectedDay.hour
					);
				}
				return "";
			},
			shipmentAltBags() {
				let txt = "";
				if (this.alternate == "כן") {
					txt = "מאשר קבלת מוצרים חלופיים";
				} else {
					txt = "לא מאשר קבלת מוצרים חלופיים";
				}
				if (this.nobags) {
					txt = txt + "<br />משלוח ללא שקיות ניילון";
				}
				return txt;
			},
			notes() {
				let txt = "";
				if (this.order_comments) {
					txt = this.order_comments;
				}
				if (this.order_comments2) {
					if (txt) {
						txt = txt + "<br />";
					}
					txt = txt + this.order_comments2;
				}
				return txt;
			},
			done: {
				get() {
					if (this.$store.state.checkoutStage === "info") {
						this.check = false;
					}
					return this.check;
				},
				set(value) {
					this.check = true;
				}
			},
			jsonShip() {
				return JSON.stringify(this.selectedDay);
			},

			shippingTimes() {
				let s = Object.values(this.slots);
        return this.$store.state.emergencyMode.officecore ? s.slice(0,6) : s.slice(0,3);
			},
			loadingSlots() {
				if (!this.slots) {
					return true;
				}
				return false;
			},
			shippingTimesForPop() {
				let s = Object.values(this.slots);
				return s;
			},
			slotsLoaded() {
				this.done = false;
				this.check = false;
				this.editInputs = true;
				if (!this.$store.state.orderEdit) {
					this.timeValid = false;
				}
				return Object.values(this.slots).length > 0 ? true : false;
			}
		},
		mounted() {
			if (this.order_comments || this.order_comments2) {
				this.firstShowComments = true;
        this.order_comments_open = true;
			}
			var $this = this;
			this.$root.$on("removeOtherAddress", function(event) {
				$this.editInputs = true;
			});

			if (this.$store.state.orderEdit) {
				this.selectedDay = {
					date: this.orderEditMeta.meta.jckwds_date[0],
					day:
						typeof this.orderEditMeta.meta.jckwds_day != "undefined"
							? this.orderEditMeta.meta.jckwds_day[0]
							: "",
					hour: this.orderEditMeta.meta.jckwds_timeslot[0],
					id: this.orderEditMeta.meta.jckwds_slotIndex[0]
				};

				this.selectedHour = {
					hourId: parseInt(this.orderEditMeta.meta.jckwds_slotIndex[0]),
					slotIndex: this.orderEditMeta.meta.jckwds_date[0]
				};

				this.timeValid = true;
				this.showError = false;
				this.alternate = parseInt(this.orderEditMeta.meta.order_alternateproducts[0]) ? "כן" : "לא";
				this.nobags = this.orderEditMeta.meta.order_nobags ? this.orderEditMeta.meta.order_nobags[0] : "";
				this.order_comments = this.orderEditMeta.meta.order_comments
					? this.orderEditMeta.meta.order_comments[0]
					: "";
				this.order_comments2 = this.orderEditMeta.meta.order_comments2
					? this.orderEditMeta.meta.order_comments2[0]
					: "";
			}

			this.$store.commit("setPermOrderEdit", false);
			this.$store.commit("setPremenantOrder", false);
		},
		methods: {
      ...mapActions(["getShipSlots"]),
			toggleEditInputs() {
				this.editInputs = true;
				this.done = false;
				this.check = false;
				this.$store.commit("changeCheckoutStage", "shippment");
				this.$root.$emit("stage-complete", 1);
			},
			changeTab(tab) {
				this.$validator
					.validate()
					.then(result => {
						if (result && this.timeValid) {
							// Send CID to backend
							if (
								// Check that all objects and functions exist
								window &&
								window.ga &&
								typeof window.ga.getAll === "function" &&
								typeof window.ga.getAll()[0] === "object" &&
								typeof window.ga.getAll()[0].get === "function"
            ) {
								let wp_user_id = this.$store.getters.userCheckoutInfo.id
									? this.$store.getters.userCheckoutInfo.id
									: false;
								let cid = window.ga.getAll()[0].get("clientId");
								if (wp_user_id && cid) {
									this.$ajax
										.get(
											this.$wpData.ajax_url +
												"?action=setCustomerCID&user_id=" +
												wp_user_id +
												"&cid=" +
												cid
										)
										.then(response => {
											/* Do nothing really... */
										});
								}
							}

							this.editInputs = false;
							this.done = true;
							this.$root.$emit("stage-complete", 2);
							this.$store.commit("changeCheckoutStage", tab);
							if (this.$mq == "mobile") {
								mobileToggle($(".check_col3 h2"));
								setTimeout(() => {
									const paymentDomElement = document.querySelector(
										".right.check_col.check_col3.m_toggle"
									);
									paymentDomElement.scrollIntoView({ behavior: "smooth" });
								}, 300);
							}
						}
						if (result && !this.timeValid) {
							this.showError = true;
						}
						if (!result && !this.timeValid) {
							this.showError = true;
						}
					})
					.catch(err => {});
			},
			selectHour(event, hourId, slot_index, employee_number) {
				this.selectedFar = [];
				this.selectedHour = {
					hourId: hourId,
					slotIndex: slot_index,
					employee_number: employee_number
				};
			},
			handleSelected(value) {
				this.selectedHour = value;
				var shipping = Object.values(this.slots);
				shipping.map((day, index) => {
					if (day.date == value.slotIndex) {
						day.hours.map(time => {
							if (time.id == value.hourId) {
								this.selectedFar = [];
								this.selectedFar.push(day);
							}
						});
					}
				});
			},
			openHours() {
				this.$modal.show("hours-modal");
			},
      order_comments_toggle() {
        this.order_comments_open = !this.order_comments_open;
      },
      changeToLocalPickup() {
        this.$store.commit("setLocalPickup", true);

        this.check = false;
        this.done = false;

        this.$store.state.coordinates.address = 'הסדנא 5 - חולון, איסוף עצמי';
        this.$store.state.coordinates.x = '34.8012307';
        this.$store.state.coordinates.y = '32.0217035';

        if (
            this.$store.state.createPermenantOrder == "true" ||
            this.$store.state.createPermenantOrder
        ) {
          this.getShipSlots(["1", true]);
        } else {
          this.getShipSlots(["1", false]);
        }
      }
		},
		components: {
			OK,
			SHIPP,
			PEN,
			HoursPop
		}
	};
</script>

<style lang="scss" scoped>
.change-to-local-pickup {
  margin: -10px 0 18px;
  a {
    text-decoration: underline;
    font-weight: bold;
  }
  .green {
    font-weight: bold;
  }
}
</style>
<style>
	.addnotes.active .inner_note {
		display: none;
	}
	.inner_note {
		font-size: 14px;
		color: grey;
	}
	.inner_note__title {
		font-weight: 700;
	}
	.slotsLoader span {
		display: block;
		margin-bottom: 20px;
	}
	.slotsLoader {
		display: block;
		text-align: center;
		padding: 30px 0;
	}
  .shipp_time_hour {
    direction: ltr;
  }
</style>
